import { useQuery } from '@tanstack/react-query'

import { IS_FEDRAMP_ENVIRONMENT } from '@/constants/env'

import { bookmarkCheckQueryKeys } from '@/hooks/bookmarks/types'

import type { BookmarkableType } from '@/types/bookmark/Bookmark'
import type { UUID } from '@/types/Id'

import { useBookmarkCheckLoader } from '@/services/bookmark-check-loader/context'

interface UseCheckBookmarkProps {
  orgId: UUID | ''
  bookmarkableType: BookmarkableType
  objectId: string
  enabled?: boolean
}

export const useCheckBookmark = ({
  orgId,
  bookmarkableType,
  objectId,
  enabled = true,
}: UseCheckBookmarkProps) => {
  const loader = useBookmarkCheckLoader()

  return useQuery({
    queryKey: bookmarkCheckQueryKeys.check({
      orgId,
      bookmarkableType,
      objectId,
    }),
    queryFn: () => loader!.load(`${bookmarkableType}:${objectId}`),
    enabled:
      !IS_FEDRAMP_ENVIRONMENT && !!loader && enabled && !!orgId && !!objectId,
    staleTime: 1000 * 60 * 5, // 5 minutes
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  })
}
